import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { OrganizationalUnit } from '@wilson/interfaces';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrganizationalUnitsState } from './state/organizational-unit-state.state';
import { FetchOrgUnits } from './state/organizational-unit-state.action';

@Injectable({
  providedIn: 'root',
})
export class OrganizationalUnitHelperService {
  private readonly store = inject(Store);

  getOrgUnitNameById(
    orgUnitId: string,
    emptyStringOnError: boolean,
  ): Observable<string | undefined> {
    return this.store.dispatch(new FetchOrgUnits()).pipe(
      switchMap(() =>
        this.store.select(
          OrganizationalUnitsState.getOrganizationalUnitById(orgUnitId),
        ),
      ),
      map((orgUnit: OrganizationalUnit | undefined) => {
        return orgUnit ? orgUnit.name : this.handleError(emptyStringOnError);
      }),
      catchError((error) => {
        console.error('Failed to fetch org unit name:', error);
        return of(this.handleError(emptyStringOnError));
      }),
    );
  }

  handleError(emptyStringOnError: boolean): string {
    if (emptyStringOnError) {
      return '';
    } else {
      return 'general.n/a';
    }
  }
}
